import { ChangeDetectionStrategy, Component, Input, OnInit, input, output } from '@angular/core';
import { DotsLoaderComponent } from '../../../shared/components/dots-loader/dots-loader.component';
import { ClickCursorDirective } from '../../../shared/directives/click-cursor.directive';

@Component({
  selector: 'gnx-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ClickCursorDirective, DotsLoaderComponent],
})
export class CardComponent implements OnInit {
  readonly title = input<string>(undefined);
  @Input() note: string;
  readonly loading = input<boolean>(undefined);
  readonly loaded = input<boolean>(undefined);
  @Input() emptyLabel: boolean;
  readonly errorLabel = input<boolean>(undefined);
  @Input() footerCTA: string;
  readonly footerCTAClick = output<void>();

  constructor() {}

  ngOnInit(): void {}
}
